module.exports = __webpack_public_path__ + "assets/img/smartTV-module5-8.1.cdaf363c.png";